import type { FC, HTMLAttributes } from "react";

import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import { useTranslations } from "@jti/ui";

import useSubscriptionBillingDate from "@checkout/hooks/useSubscriptionBillingDate";

import styles from "./SubscriptionBillingDisclaimer.module.scss";

const { sanitize } = dompurify;

type SubscriptionBillingDisclaimerProps = HTMLAttributes<HTMLParagraphElement>;

export const SubscriptionBillingDisclaimer: FC<SubscriptionBillingDisclaimerProps> = ({ className, ...props }) => {
  const { __ } = useTranslations();
  const billingDate = useSubscriptionBillingDate();
  const billingDateText = billingDate
    ? __("summarySubscription.nextBilling", [billingDate])
    : __("summarySubscription.nextBillingError");

  return (
    <p
      className={classNames(styles.disclaimer, className)}
      data-testid="subscription-billing-disclaimer"
      dangerouslySetInnerHTML={{
        __html: sanitize(billingDateText),
      }}
      {...props}
    ></p>
  );
};
